<template>
    <div class="xy_class">
        <v-header></v-header>
        <div class="newContent">
            <h1 style="text-align: center;"><strong>用户协议</strong></h1>
            <div style="text-align: center;"><hr></div>
            <p style="text-align: right;margin: 0;">更新日期：2021年12月29日</p>
            <p style="text-align: right;margin: 0;">生效日期：2021年12月29日</p>
            <p>欢迎使用小查线索，在您使用小查线索提供的各项VIP会员及非会员服务（以下简称“服务”）之前，请务必仔细阅读并透彻理解本协议。</p>
            <p>如您不同意本协议及其更新内容，您可以主动取消小查线索提供的服务；您一旦使用小查线索的服务，即视为您已了解并完全同意本协议的各项内容， 并成为小查线索用户（以下简称“用户”）。小查线索有权在必要时修改用户协议，一旦本协议的内容发生变动，小查线索将会在相关的页面上提示修改内容。变动结果将在小查线索通知之日起生效。如果您不同意所改动的内容，您有权停止使用小查线索的服务，如果您继续使用小查线索的各项服务，则视为接受服务条款的变动。用户理解并同意：小查线索具有保留修改或中断部分或全部服务的权利。</p>
            <p>一、服务内容</p>
            <p>小查线索提供给用户一个功能强大、响应迅捷的检索与识别的软件工具，该软件系统基于用户所提出和输入的指令，经过检索、分析、计算、辨识等复杂的软件系统处理后，最终生成检索与识别结果并呈现给用户。</p>
            <p>二、合规声明</p>
            <p>
                北京信查查信用管理有限公司所开发、运营的大数据软件小查线索是一款企业相关数据等公开信息查询系统。根据用户指令，小查线索的搜索引擎系统会以非人工检索方式自动生成用户检索的已经依法公开的企业信息，以便用户能够找到和使用该已被公开信息。小查线索目前网站公示数据来源为互联网公开信息，包括但不限于以下网站，现就数据来源及其合规性简述如下：<br/>
                <span>1、<a href="http://www.gsxt.gov.cn/index.html">全国企业信用信息公示系统</a></span><br/>
                <span>2、<a href="http://beian.miit.gov.cn/">ICP/IP地址/域名信息备案管理系统</a></span><br/>
                <span>3、<a href="http://sbj.cnipa.gov.cn/">中国商标网</a></span><br/>
                <span>4、市场主体官方网站</span><br/>
                <span>5、各大主流垂直行业网站</span>
            </p>
            <p>
                小查线索自身不主动编辑或修改被所公示网站上的信息的内容或其表现形式，仅对相关网站依法公示的信息如实展示。因此，小查线索无法保证该数据与信息的完整的真实与时效性。同时，用户在使用小查线索时说明其已经理解并接受以下情形的免责声明：</br>
                <span>1、小查线索对由于用户不正当使用本网站服务、或依据本网站信息进行交易引起的对任何第三方的损害不承担任何赔偿责任；</span></br>
                <span>2、小查线索不声明或保证本网站或可从本网站下载的内容不带有计算机病毒或类似垃圾或破坏功能；</span></br>
                <span>3、小查线索不担保本网站服务一定能满足用户的要求，不对页面内容的删除或储存失败负责；</span></br>
                <span>4、若小查线索已经明示本网站运营方式发生变更并提醒用户应当注意事项，用户未按要求操作所产生的一切后果由用户自行承担；</span></br>
                <span>5、已经注册为小查线索会员的用户，在超出会员服务范围外要求的其他服务可能会产生额外的费用由用户自己承担。</span></br>
                <span>6、小查线索对由于政府禁令、现行生效的适用法律或法规的变更、火灾、地震、动乱、战争、停电、通讯线路中断、黑客攻击、计算机病毒侵入或发作、电信部门技术调整、因政府管制而造成网站的暂时性关闭等任何影响网络正常运营的不可预见、不可避免、不可克服和不可控制的事件（“不可抗力事件”），以及他人蓄意破坏，正常的系统维护、系统升级，或者因网络拥塞而导致本网站不能访问而造成的本站所提供的信息及数据的延误、停滞或错误，使用者由此受到的一切损失不承担任何责任。</span></br>
                <span>7、用户确认其知悉由于用户本人将密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄漏，或其他非因小查线索平台原因导致的个人信息的泄漏，小查线索概不负责。</span></br>
                <span>8、用户确认其知悉，使用本网站提供的服务涉及到互联网服务，可能会受到各个环节不稳定因素的影响。因此服务存在因国家相关行业主管部门及电信运营商的调整、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。用户须承担以上风险，小查线索不作担保。对因此导致用户不能发送、接受阅读消息和接发错消息，或无法实现其他通讯条件，小查线索不承担任何责任。</span></br>
                <span>9、如果您不是具备完全民事权利能力和完全民事行为能力的自然人，您无权使用小查线索服务，因此小查线索希望您不要向我们提供任何个人信息。</span>
            </p>
        </div>
        <v-footer></v-footer>
    </div>
</template>
<script>
import vHeader from './common/header.vue'
import vFooter from './common/footer.vue'
export default {
    data(){
        return{

        }
    },
    components:{
        vHeader,
        vFooter
    }
}
</script>
<style lang="scss" scoped>
.newContent{
    height: auto;
    margin: 20px auto;
    line-height: 2;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/agreement.vue